import React, { useId } from 'react';
import { Stack, Text } from 'rsuite';

const BasicStyledCheckbox = ({ label, onChange, ...rest }) => {
  const id = useId();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={4}
    >
      <Stack.Item>
        <label
          id={`${id}-label`}
          className={`checkbox style-d`}
        >
          <input
            id={`${id}`}
            aria-label={`${id}-label`}
            onChange={(e) => {
              onChange(e.target.checked);
            }}
            type="checkbox"
            {...rest}
          />
          <div className={`checkbox__checkmark`}></div>
        </label>
      </Stack.Item>
      {label && (
        <Stack.Item>
          <Text>{label}</Text>
        </Stack.Item>
      )}
    </Stack>
  );
};

export default BasicStyledCheckbox;
